"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _LoyaltyTokenComponent = _interopRequireDefault(require("./LoyaltyTokenComponent"));
var _loyaltyFeeActions = require("../../redux/actions/loyaltyFeeActions");
var _userActions = require("../../redux/actions/userActions");
var _loyaltyTokenSelectors = require("../../redux/selectors/loyaltyTokenSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _loyaltyTokenSelector = (0, _loyaltyTokenSelectors.loyaltyTokenSelector)(state),
    loyaltyOMSEnabled = _loyaltyTokenSelector.loyaltyOMSEnabled,
    loyaltyOMSProducts = _loyaltyTokenSelector.loyaltyOMSProducts;
  var currentAccount = (0, _loyaltyTokenSelectors.currentAccountloyaltyTokenSelector)(state);
  return {
    loyaltyOMSEnabled: loyaltyOMSEnabled,
    loyaltyOMSProducts: loyaltyOMSProducts,
    currentAccount: currentAccount
  };
};
var mapDispatchToProps = {
  getOperatorLoyaltyFeeConfigs: _loyaltyFeeActions.getOperatorLoyaltyFeeConfigs,
  updateAccount: _userActions.updateAccount
};
var LoyaltyTokenContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LoyaltyTokenComponent["default"]);
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: 'loyaltyTokenForm',
  onSubmit: function onSubmit() {}
})(LoyaltyTokenContainer);